<template lang='pug'>
  div.columns.is-vcentered.is-mobile
    .column.has-text-centered
      h1.has-text-centered  Esperando por Permissão
      Button3d.m.has-text-white.has-text-weight-bold(@click="tryAgain()", color="success", size="large") TENTAR NOVAMENTE
      Button3d.m.has-text-white.has-text-weight-bold(@click="askAgain()", color="danger", size="large") REFAZER PEDIDO

</template>
<script>
import { API } from '../../services'
import swal from 'sweetalert2'
import router from '../../router/router'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['accessData'])
  },
  async beforeMount () {
    await this.tryAgain(false)
  },
  methods: {
    async tryAgain (showSwal = true) {
      try {
        const result = await API.device.get({
          id: this.accessData.browserRecord.id
        })

        if (result.data.success ? result.data.success.active : false) {
          await this.$store.dispatch('getBrowserRecordInfo')
          this.$router.push({name: 'password'})
        } else if (showSwal === true) {
          swal({ type: 'info', text: 'Permissão ainda pendente' })
        }
      } catch (e) {
        console.error(e)
      }
    },
    async askAgain () {
      try {
        await API.getAccessInfo.delete({
          id: this.accessData.browserRecord.id
        })
        router.push('/clear')
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style scoped>
.m {
  margin: 10px;
}
</style>
